import { Paper } from "@material-ui/core"
import { useState } from "react"
import type { FormEvent, ReactElement } from "react"
import { useSearch } from "../../../hooks/useSearch"
import { Caption, SearchButton } from "../../atoms"
import { SearchField } from "../../molecules"

import "./search-bar.styles.scss"
import { useTranslation } from "react-i18next"

export function SearchBar(): ReactElement {
  const { id, disableNavigation, small, search, searchValue } = useSearch()
  const { t } = useTranslation("search")

  const [focus, setFocus] = useState<boolean>(false)
  const showSearchInfo: boolean = searchValue.length > 0 && searchValue.length < 3 && !searchValue.startsWithNumber()

  return (
    <div className="search-bar">
      <Paper
        id={id}
        elevation={0}
        className={`search-bar-internal ${small ? "small" : ""} ${focus ? "focus" : ""}`}
        data-mdat-item-id="search-bar"
      >
        {disableNavigation ? (
          <div className="search-bar-container">
            <SearchField setFocus={setFocus} />
            <SearchButton />
          </div>
        ) : (
          <form
            className="search-bar-container"
            onSubmit={(event: FormEvent<HTMLFormElement>) => {
              event.preventDefault()
              search()
            }}
          >
            <SearchField setFocus={setFocus} />
            <SearchButton />
          </form>
        )}
      </Paper>
      {showSearchInfo && <Caption>{t("minSearchCharacters")}</Caption>}
    </div>
  )
}
